/**
 * 报表 action
 */
import * as ofbiz from '../server/ofbiz';
import Utils from '../script/utils.js';

export const SET_CHECKERRORREPORT = 'SET_CHECKERRORREPORT';
export const SET_CHECKSTATISTICSREPORT = 'SET_CHECKSTATISTICSREPORT';
export const SET_ERRORREPORTMONITORMAP = 'SET_ERRORREPORTMONITORMAP';
export const SET_STATISTICSREPORTMONITORMAP = 'SET_STATISTICSREPORTMONITORMAP';
export const SET_CHECKERRORREPORTFILES = 'SET_CHECKERRORREPORTFILES';
export const SET_CHECKSTATISTICSREPORTFILES = 'SET_CHECKSTATISTICSREPORTFILES';
export const SET_TOPNREPORTFILES = 'SET_TOPNREPORTFILES';
export const SET_TOPNREPORTMONITORMAP = 'SET_TOPNREPORTMONITORMAP';
export const SET_TOPNREPORT = 'SET_TOPNREPORT';

const REPORT_SUBTYPE = {
  ERROR: 'ERROR',
  STATISTICS: 'STATISTICS',
  TOPN: 'TOPN',
};

export function setCheckErrorReport(checkErrorReport) {
  return { type: SET_CHECKERRORREPORT, checkErrorReport };
}

export function setCheckStatisticsReport(checkStatisticsReport) {
  return { type: SET_CHECKSTATISTICSREPORT, checkStatisticsReport };
}

export function setTopNReport(topNReport) {
  return { type: SET_TOPNREPORT, topNReport };
}

export function setErrorReportMonitorMap(errorReportMonitorMap) {
  return { type: SET_ERRORREPORTMONITORMAP, errorReportMonitorMap };
}

export function setStatisticsReportMonitorMap(statisticsReportMonitorMap) {
  return { type: SET_STATISTICSREPORTMONITORMAP, statisticsReportMonitorMap };
}

export function setTopNReportMonitorMap(topNReportMonitorMap) {
  return { type: SET_TOPNREPORTMONITORMAP, topNReportMonitorMap };
}

export function setCheckErrorReportFiles(checkErrorReportFiles) {
  return { type: SET_CHECKERRORREPORTFILES, checkErrorReportFiles };
}

export function setCheckStatisticsReportFiles(checkStatisticsReportFiles) {
  return { type: SET_CHECKSTATISTICSREPORTFILES, checkStatisticsReportFiles };
}

export function setTopNReportFiles(topNReportFiles) {
  return { type: SET_TOPNREPORTFILES, topNReportFiles };
}

export function getCheckErrorReport(callback){
  return dispatch => fetchReportList(dispatch, REPORT_SUBTYPE.ERROR, setCheckErrorReport, setErrorReportMonitorMap, callback);
}

export function getCheckStatisticsReport(callback){
  return dispatch => fetchReportList(dispatch, REPORT_SUBTYPE.STATISTICS, setCheckStatisticsReport, setStatisticsReportMonitorMap, callback);
}

export function getTopNReport(callback){
  return dispatch => fetchReportList(dispatch, REPORT_SUBTYPE.TOPN, setTopNReport, setTopNReportMonitorMap, callback);
}

export function addCheckErrorReport(params, callback, errorCallback) {
  return dispatch => createReportWithMonitors(REPORT_SUBTYPE.ERROR, params, callback, errorCallback);
}

export function addCheckStatisticsReport(params, callback, errorCallback) {
  return dispatch => createReportWithMonitors(REPORT_SUBTYPE.STATISTICS, params, callback, errorCallback);
}

export function addTopNReport(params, callback, errorCallback) {
  return dispatch => createReportWithMonitors(REPORT_SUBTYPE.TOPN, params, callback, errorCallback);
}

export function updateCheckErrorReport(params, callback, errorCallback) {
  return dispatch => updateReportWithMonitors(REPORT_SUBTYPE.ERROR, params, callback, errorCallback);
}

export function updateCheckStatisticsReport(params, callback, errorCallback) {
  return dispatch => updateReportWithMonitors(REPORT_SUBTYPE.STATISTICS, params, callback, errorCallback);
}

export function updateTopNReport(params, callback, errorCallback) {
  return dispatch => updateReportWithMonitors(REPORT_SUBTYPE.TOPN, params, callback, errorCallback);
}

export function deleteCheckErrorReport(params, callback, errorCallback) {
  return dispatch => deleteReportByParams(params, callback, errorCallback);
}

export function deleteCheckStatisticsReport(params, callback, errorCallback) {
  return dispatch => deleteReportByParams(params, callback, errorCallback);
}

export function deleteTopNReport(params, callback, errorCallback) {
  return dispatch => deleteReportByParams(params, callback, errorCallback);
}

export function deleteReportFiles(RecId, callback, errorCallback) {
  return dispatch => {
    ofbiz.deleteReportFile(RecId).then(() => {
      callback && callback(RecId);
    }).catch((err) => {
      errorCallback && errorCallback(err);
      Utils.showInterfaceErrorInfo(err);
    });
  }
}

function fetchReportFiles(dispatch, setFilesAction, reportId, callback) {
  ofbiz.getReportFiles(reportId).then((res) => {
    const list = getList(res).map(normalizeReportFileItem);
    dispatch(setFilesAction(list));
    callback && callback(list.length ? 1 : 0);
  }).catch((err) => {
    dispatch(setFilesAction([]));
    callback && callback(0);
    Utils.showInterfaceErrorInfo(err);
  });
}

export function getCheckErrorReportFiles(reportId, callback){
  return dispatch => fetchReportFiles(dispatch, setCheckErrorReportFiles, reportId, callback);
}

export function getCheckStatisticsReportFiles(reportId, callback) {
  return dispatch => fetchReportFiles(dispatch, setCheckStatisticsReportFiles, reportId, callback);
}

export function getTopNReportFiles(reportId, callback) {
  return dispatch => fetchReportFiles(dispatch, setTopNReportFiles, reportId, callback);
}

export function startOrStopCheckErrorReport(params, callback){
  return dispatch => toggleReportByParams(params, callback);
}

export function startOrStopCheckStatisticsReport(params, callback){
  return dispatch => toggleReportByParams(params, callback);
}

export function startOrStopTopNReport(params, callback){
  return dispatch => toggleReportByParams(params, callback);
}

export function createReportManual(params, callback, errorCallback) {
  return dispatch => {
    // 对齐老版 rest/report/create：id=报表配置 id，reporttype=error/statistics/topn
    ofbiz.generateReport(params.reportId, params.reporttype).then((data) => {
      callback && callback(data);
    }).catch((err) => {
      errorCallback && errorCallback(err);
      Utils.showInterfaceErrorInfo(err);
    });
  }
}

export function exportReport(params, callback, errorCallback) {
  return dispatch => {
    // params.ids 为文件表格勾选的 RecId 数组，后端打包 zip 后返回下载地址
    ofbiz.exportOtherReports(params.ids).then((url) => {
      if (url) {
        triggerDownload(url);
      }
      callback && callback(url);
    }).catch((err) => {
      errorCallback && errorCallback(err);
      Utils.showInterfaceErrorInfo(err);
    });
  }
}

/** 报表生成记录 → 老版 ReportFiles 字段（表格列 ReportFileName/TimePeriod/... 直接可用） */
function normalizeReportFileItem(item = {}) {
  return {
    ...item,
    RecId: item.fileId || item.RecId || item.id,
    ReportName: item.reportName || item.ReportName || '',
    ReportFileName: item.fileName || item.ReportFileName || '',
    TimePeriod: item.timePeriod || item.TimePeriod || '',
    CreatedDateTime: item.createdDate || item.CreatedDateTime || '',
    ReportFileFormat: item.format || item.ReportFileFormat || '',
    CreatedBy: item.creator || item.CreatedBy || '',
  };
}

/** 通过隐藏 iframe 触发浏览器下载（同源部署自动携带 JSESSIONID Cookie） */
function triggerDownload(url) {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  document.body.appendChild(iframe);
  setTimeout(() => {
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
  }, 60000);
}

function fetchReportList(dispatch, reportSubtype, setListAction, setMonitorMapAction, callback) {
  ofbiz.getReportList({ reportSubtype }, 1, 500).then((res) => {
    const list = getList(res).map(normalizeReportItem);
    dispatch(setListAction(list));
    return Promise.all(list.map(report => {
      const reportId = getReportId(report);
      if (!reportId) {
        return Promise.resolve([reportId, []]);
      }
      return ofbiz.getReportMonitors(reportId)
        .then(monitors => [reportId, normalizeReportMonitors(monitors, report)])
        .catch(() => [reportId, normalizeReportMonitors([], report)]);
    })).then((entries) => {
      const monitorMap = {};
      entries.forEach(([reportId, monitors]) => {
        if (reportId) {
          monitorMap[reportId] = monitors;
        }
      });
      dispatch(setMonitorMapAction(monitorMap));
      callback && callback(list);
    });
  }).catch((err) => {
    dispatch(setListAction([]));
    dispatch(setMonitorMapAction({}));
    callback && callback([]);
    Utils.showInterfaceErrorInfo(err);
  });
}

function createReportWithMonitors(reportSubtype, params, callback, errorCallback) {
  const monitorIds = params.checkedKeys || [];
  const payload = normalizeReportPayload(params.report, reportSubtype, monitorIds);
  ofbiz.createReport(payload).then((data) => {
    const reportId = getReportId(data) || getReportId(data && data.report) || data;
    if (!reportId) {
      callback && callback(data);
      return;
    }
    ofbiz.assignReportMonitors(reportId, monitorIds).then(() => {
      callback && callback(normalizeReportItem({ ...payload, ...data, reportId }));
    }).catch(() => {
      callback && callback(normalizeReportItem({ ...payload, ...data, reportId }));
    });
  }).catch((err) => {
    errorCallback && errorCallback(err);
    Utils.showInterfaceErrorInfo(err);
  });
}

function updateReportWithMonitors(reportSubtype, params, callback, errorCallback) {
  const report = params.report || {};
  const monitorIds = params.checkedKeys || [];
  const payload = normalizeReportPayload(report, reportSubtype, monitorIds);
  const reportId = getReportId(payload);
  ofbiz.updateReport(payload).then((data) => {
    if (!reportId) {
      callback && callback(normalizeReportItem({ ...payload, ...data }));
      return;
    }
    ofbiz.assignReportMonitors(reportId, monitorIds).then(() => {
      callback && callback(normalizeReportItem({ ...payload, ...data }));
    }).catch(() => {
      callback && callback(normalizeReportItem({ ...payload, ...data }));
    });
  }).catch((err) => {
    errorCallback && errorCallback(err);
    Utils.showInterfaceErrorInfo(err);
  });
}

function deleteReportByParams(params, callback, errorCallback) {
  const reportId = getReportId(params);
  ofbiz.deleteReport(reportId).then((data) => {
    callback && callback(data);
  }).catch((err) => {
    errorCallback && errorCallback(err);
    Utils.showInterfaceErrorInfo(err);
  });
}

function toggleReportByParams(params, callback) {
  const reportId = getReportId(params);
  ofbiz.toggleReportStatus(reportId).then((data) => {
    callback && callback(normalizeReportItem(data || params));
  }).catch((err) => {
    callback && callback({ errorCode: 1, errmsg: err.message });
    Utils.showInterfaceErrorInfo(err);
  });
}

function normalizeReportPayload(report = {}, reportSubtype, monitorIds = []) {
  const payload = {
    reportId: getReportId(report),
    reportName: report.reportName || report.ReportName,
    reportDesc: report.reportDesc || report.ReportDesc,
    reportSubtype,
    reportType: report.reportType || report.ReportType,
    dayCreateTime: report.dayCreateTime || report.DayCreateTime || report.ReportCreateTime,
    weekCreateTime: report.weekCreateTime || report.WeekCreateTime || report.WeekTime,
    email: report.email || report.Email,
    status: normalizeStatus(report.status !== undefined ? report.status : report.Status),
    monitorType: report.monitorType || report.MonitorType,
    monitorIndex: report.monitorIndex || report.MonitorIndex,
    sortord: report.sortord || report.Sortord,
    valueWay: report.valueWay || report.ValueWay,
    reportFileFormat: report.reportFileFormat || report.ReportFileFormat,
    customStartTime: report.customStartTime || report.CustomStartTime,
    customEndTime: report.customEndTime || report.CustomEndTime,
    showChart: report.showChart !== undefined ? report.showChart : report.ShowChart,
    chartType: report.chartType || report.ChartType,
    showError: report.showError !== undefined ? report.showError : report.ShowError,
    showWarning: report.showWarning !== undefined ? report.showWarning : report.ShowWarning,
    showMessage: report.showMessage !== undefined ? report.showMessage : report.ShowMessage,
    monitorIds: monitorIds.join(','),
  };
  Object.keys(payload).forEach(key => {
    if (payload[key] === undefined || payload[key] === null) {
      delete payload[key];
    }
  });
  return payload;
}

function normalizeReportItem(item = {}) {
  const reportId = getReportId(item);
  const normalized = {
    ...item,
    reportId,
    reportName: item.reportName || item.ReportName || item.workEffortName,
    reportDesc: item.reportDesc || item.ReportDesc || item.description,
    reportType: item.reportType || item.ReportType,
    reportSubtype: item.reportSubtype || item.ReportSubtype,
    dayCreateTime: item.dayCreateTime || item.DayCreateTime || item.ReportCreateTime,
    weekCreateTime: item.weekCreateTime || item.WeekCreateTime || item.WeekTime,
    email: item.email || item.Email,
    status: normalizeStatus(item.status !== undefined ? item.status : item.Status),
    monitorType: item.monitorType || item.MonitorType,
    monitorIndex: item.monitorIndex || item.MonitorIndex,
    sortord: item.sortord || item.Sortord,
    valueWay: item.valueWay || item.ValueWay,
    reportFileFormat: item.reportFileFormat || item.ReportFileFormat,
    monitorIds: item.monitorIds || item.MonitorIds,
    createdDateTime: item.createdDateTime || item.CreatedDateTime,
  };

  // 临时兼容仍在旧字段上渲染的表格/弹窗；数据源仍来自新接口。
  normalized.RecId = normalized.reportId;
  normalized.ReportName = normalized.reportName;
  normalized.ReportDesc = normalized.reportDesc;
  normalized.ReportType = normalized.reportType;
  normalized.DayCreateTime = normalized.dayCreateTime;
  normalized.ReportCreateTime = normalized.dayCreateTime;
  normalized.WeekCreateTime = normalized.weekCreateTime;
  normalized.WeekTime = normalized.weekCreateTime;
  normalized.Email = normalized.email;
  normalized.Status = normalized.status === 'DISABLED';
  normalized.MonitorType = normalized.monitorType;
  normalized.MonitorIndex = normalized.monitorIndex;
  normalized.Sortord = normalized.sortord;
  normalized.ValueWay = normalized.valueWay;
  normalized.ReportFileFormat = normalized.reportFileFormat;
  normalized.CreatedDateTime = normalized.createdDateTime;
  return normalized;
}

function normalizeReportMonitors(res, report = {}) {
  const list = getList(res);
  if (list.length) {
    return list.map(item => normalizeReportMonitor(item, report));
  }
  const ids = (report.monitorIds || '').split(',').map(item => item.trim()).filter(Boolean);
  return ids.map(monitorId => normalizeReportMonitor({ monitorId }, report));
}

function normalizeReportMonitor(item = {}, report = {}) {
  const monitorId = item.monitorId || item.MonitorID || item.fixedAssetId || item.RecId || item.id;
  return {
    ...item,
    reportId: getReportId(report) || item.reportId || item.ReportID,
    monitorId,
    monitorName: item.monitorName || item.MonitorName || item.fixedAssetName || item.name,
    MonitorID: monitorId,
    ReportID: getReportId(report) || item.reportId || item.ReportID,
    RecId: item.relationId || item.RecId || `${getReportId(report) || ''}_${monitorId || ''}`,
  };
}

function getList(res) {
  if (Array.isArray(res)) {
    return res;
  }
  if (!res) {
    return [];
  }
  return res.list || res.items || res.records || res.monitors || (res.data && getList(res.data)) || [];
}

function getReportId(item = {}) {
  return item.reportId || item.workEffortId || item.RecId || item.id;
}

function normalizeStatus(status) {
  if (status === true) return 'DISABLED';
  if (status === false) return 'ENABLED';
  if (!status) return undefined;
  return status;
}
